import { Component, OnInit } from "@angular/core";
import { RatesService } from "./shared/rates.service";

import { ClientRateViewModel } from "@app/shared/models/rates/ClientRateViewModel.model";
import { DriverRateViewModel } from "@app/shared/models/rates/DriverRateViewModel.model";
import { CustomChargeViewModel } from "@app/shared/models/rates/CustomChargeViewModel.model";
import { LongevityViewModel } from "@app/shared/models/rates/LongevityViewModel.model";
import { FuelSurchargeViewModel } from "@app/shared/models/rates/FuelSurchargeViewModel.model";
import { DriverFuelSurchargeViewModel } from "@app/shared/models/rates/DriverFuelSurchargeViewModel.model";
import { InsuranceSurchargeViewModel } from "@app/shared/models/rates/InsuranceSurchargeViewModel.model";
import { ClientLaneRateViewModel } from "@app/shared/models/rates/ClientLaneRateViewModel.model";
import { DriverLaneRateViewModel } from "@app/shared/models/rates/DriverLaneRateViewModel.model";

@Component({
  selector: "app-rates-list",
  templateUrl: "./rateslist.component.html",
  styleUrls: ["./rateslist.component.css"],
})
export class RatesListComponent implements OnInit {
  clientRates: ClientRateViewModel[] = [];
  driverRates: DriverRateViewModel[] = [];
  clientLaneRates: ClientLaneRateViewModel[] = [];
  driverLaneRates: DriverLaneRateViewModel[] = [];
  customRates: CustomChargeViewModel[] = [];
  longevityRates: LongevityViewModel[] = [];
  fuelRates: FuelSurchargeViewModel[] = [];
  driverFuelRates: DriverFuelSurchargeViewModel[] = [];
  insuranceRates: InsuranceSurchargeViewModel[] = [];
  nh3Quotes: any[] = [];
  cryoQuotes: any[] = [];

  sessionId = "rateslistSettings";
  quoteBuilderSelectedQuoteKey = "quoteBuilderSelectedQuote";
  currentTab: string = "Client";

  constructor(private ratesService: RatesService) {}

  ngOnInit() {
    this.ratesService.getClientRates().subscribe((rates: any) => {
      this.clientRates = rates;
    });
    this.ratesService.getDriverRates().subscribe((rates: any) => {
      this.driverRates = rates;
    });
    this.ratesService.getClientLaneRates().subscribe((rates: any) => {
      this.clientLaneRates = rates;
    });
    this.ratesService.getDriverLaneRates().subscribe((rates: any) => {
      this.driverLaneRates = rates;
    });
    this.ratesService.getFuelSurcharges().subscribe((rates: any[]) => {
      this.fuelRates = rates;
    });
    this.ratesService.getDriverFuelSurcharges().subscribe((rates: any[]) => {
      this.driverFuelRates = rates;
    });
    this.ratesService.getInsuranceSurcharges().subscribe((rates: any[]) => {
      this.insuranceRates = rates;
    });
    this.ratesService.getLongevityList().subscribe((rates: any[]) => {
      this.longevityRates = rates;
    });
    this.ratesService.getCustomChargesAndGuarantees().subscribe((rates: any[]) => {
      this.customRates = rates;
    });
    this.ratesService.getNH3Quotes().subscribe((quotes: any[]) => {
      this.nh3Quotes = quotes || [];
    });
    this.ratesService.getCryoQuotes().subscribe((quotes: any[]) => {
      this.cryoQuotes = quotes || [];
    });

    const settingsJson = sessionStorage.getItem(this.sessionId);
    const settings = settingsJson ? JSON.parse(settingsJson) : null;

    if (settings) {
      this.currentTab = settings.currentTab;
    } else {
      this.setTab("Client");
    }
  }

  setTab(tabName: string) {
    this.currentTab = tabName;
    this.saveSetting("currentTab", tabName);
  }

  saveSetting(settingName: string, settingValue: any) {
    const settingsJson = sessionStorage.getItem(this.sessionId);
    let settings = settingsJson ? JSON.parse(settingsJson) : {};
    settings[settingName] = settingValue;
    sessionStorage.setItem(this.sessionId, JSON.stringify(settings));
  }

  saveAllSettings() {
    this.setTab(this.currentTab);
  }

  onQuoteSelected(payload: any) {
    sessionStorage.setItem(this.quoteBuilderSelectedQuoteKey, JSON.stringify(payload));
    this.setTab("QuoteBuilder");
  }
}
